import { Button, Stack, Tooltip } from '@mui/material'
import type { GatheringType } from '@/types'
import { GATHERING_TYPES } from '@/types/constants'

interface Props {
  selected: GatheringType | null
  onChange: (g: GatheringType) => void
}

export function GatheringTabBar({ selected, onChange }: Props) {
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      {GATHERING_TYPES.map(({ value, label, future }) =>
        future ? (
          <Tooltip key={value} title="Coming soon" arrow>
            <span>
              <Button size="small" variant="text" disabled sx={{ minWidth: 'auto' }}>
                {label}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            key={value}
            size="small"
            variant={selected === value ? 'contained' : 'text'}
            color={selected === value ? 'warning' : 'inherit'}
            onClick={() => onChange(value as GatheringType)}
            sx={{ minWidth: 'auto', fontWeight: selected === value ? 700 : 400 }}
          >
            {label}
          </Button>
        )
      )}
    </Stack>
  )
}
